import { isNumber } from '#helper/format';

export const env = <T>(value?: T): T | undefined => {
    if(typeof value === 'string') {
        if(value === 'true' || value === 'false') {
            return (value === 'true') as T;
        }

        if(isNumber(value)) {
            return Number(value) as T;
        }
    }

    return value;
};
